var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManualVerification({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.37037 2H2.2963C2.13266 2 2 2.13266 2 2.2963V4.37037C2 4.53401 2.13266 4.66667 2.2963 4.66667H4.37037C4.53401 4.66667 4.66667 4.53401 4.66667 4.37037V2.2963C4.66667 2.13266 4.53401 2 4.37037 2Z",
    stroke: "#808389",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7063 11.333H11.6322C11.4686 11.333 11.3359 11.4657 11.3359 11.6293V13.7034C11.3359 13.867 11.4686 13.9997 11.6322 13.9997H13.7063C13.8699 13.9997 14.0026 13.867 14.0026 13.7034V11.6293C14.0026 11.4657 13.8699 11.333 13.7063 11.333Z",
    stroke: "#808389",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6641 12.667H4.66406C3.92768 12.667 3.33073 12.07 3.33073 11.3337V10.667V9.33366C3.33073 8.59728 3.92768 8.00033 4.66406 8.00033H11.3307C12.0671 8.00033 12.6641 7.40337 12.6641 6.66699V4.66699C12.6641 3.93061 12.0671 3.33366 11.3307 3.33366H5.33073",
    stroke: "#808389",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33594 6.99967C9.33594 6.26329 8.73898 5.66634 8.0026 5.66634C7.26622 5.66634 6.66927 6.26329 6.66927 6.99967V8.99967C6.66927 9.73605 7.26622 10.333 8.0026 10.333C8.73898 10.333 9.33594 9.73605 9.33594 8.99967V6.99967Z",
    fill: "#808389",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManualVerification);
export default __webpack_public_path__ + "static/media/manual-verification.c2f928e720424827a99ad0da9b9ab57b.svg";
export { ForwardRef as ReactComponent };